module.exports = __webpack_public_path__ + "static/media/Alvaro Fernandez García.eb858fee.png";